import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import JobBatches from "./pages/JobBatches";
import Candidates from "./pages/Candidates";
import HarvestPipeline from "./pages/HarvestPipeline";
import LeadGeneration from "./pages/LeadGeneration";
import LeadBoard from "./pages/LeadBoard";
import CompanyResults from "./pages/CompanyResults";
import Login from "./pages/Login";

// import ReplyHandling from "./pages/ReplyHandling";
import VoiceAgent from "./pages/VoiceAgent";
import AgentConsole from "./pages/AgentConsole";
import LeadHistory from "./pages/LeadHistory";
import BatchHistoryDetails from "./pages/BatchHistoryDetails";

function App() {
  return (
    <Routes>
      {/* Auth routes without Layout */}
      <Route path="/login" element={<Login />} />
      
      {/* Protected routes with Layout */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Navigate to="/candidate-sourcing" replace />} />
                <Route path="/candidate-sourcing" element={<LeadGeneration />} />
                <Route path="/lead-board" element={<LeadBoard />} />
                <Route path="/company-results" element={<CompanyResults />} />
                <Route path="/batch-history-details" element={<BatchHistoryDetails />} />

                {/* <Route path="/reply-handling" element={<ReplyHandling />} /> */}
                <Route path="/voice-agent" element={<VoiceAgent />} />
                <Route path="/lead-history" element={<LeadHistory />} />
                <Route path="/job-batches" element={<JobBatches />} />
                <Route path="/candidates" element={<Candidates />} />
                <Route path="/agent-console" element={<AgentConsole />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
